function e(t){return null===t||t.scrollHeight>t.clientHeight?t:e(t.parentNode)}export{e as useScrollParent};
